import { useMemo } from 'react'
import type { LogFunctions } from '../services'
import { getLogger } from '../services'

export const useLogger = (tag: string | string[]): LogFunctions => {
    return useMemo(() => getLogger(tag).value, [tag])
}
